import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import {orderBy} from "lodash"
import {RouteComponentProps} from "react-router-dom"

import Loading from "@irati/ui/src/Loading"
import authentication from "@irati/auth"
import {hangPromise} from "@irati/utils/promise"
import teamService from "@irati/identity/services/teams"
import {Team, TeamState} from "@irati/types"
import {teamsKey} from "@irati/identity/services/queries/getTeams"
import listFormat from "@irati/utils/services/graph/utils/listFormat"
import teamHierarchy, {TeamWithHierarchy} from "@shared/core/utils/team/hierarchy"

import TeamList from "../TeamList/TeamList"
import NoTeams from "../../../components/Teams/NoTeams/NoTeams"

interface Props extends RouteComponentProps {}

interface State {
  load: Promise<any> | null,
  currentTeamId?: string,
  teams: Team[],
  rootTeam: TeamWithHierarchy | null
}

class ViewTeams extends Component<Props, State> {
  listener?: ZenObservable.Subscription

  state: State = {
    load: hangPromise(),
    teams: [],
    rootTeam: null
  }

  componentDidMount() {
    // get all teams then filter down for the UI as we need all teams to work out the proper hierarchy
    this.listener = teamService
      .watchList(authentication.userTenant().uuid, {state: TeamState.All})
      .subscribe((data) => {
        this.setState({load: null})
        const rawTeams = listFormat<Team>(data.data[teamsKey])

        const {rootTeam} = teamHierarchy(rawTeams, authentication.teamAssignments())
        const teams = orderBy(rawTeams.filter((t) => t.teamState === TeamState.Generic), "teamName", "asc")
        this.setState({teams, rootTeam})
        const teamFromUrl = this.props?.location?.state?.teamName

        if (teamFromUrl) {
          const currentTeam = teams.find((team: Team) => team.teamName === teamFromUrl)
          this.setCurrentTeam(currentTeam)
        }
      })
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener.unsubscribe()
    }
  }

  setCurrentTeam = (currentTeam: Team | null) => {
    this.setState({currentTeamId: currentTeam?.uuid})
  }

  render() {
    const {load, teams, currentTeamId} = this.state
    const currentTeam = teams.find((t) => t.uuid === currentTeamId) || null

    return (
      <Row>
        <Col xs={12}>
          <Loading load={load}>
            {teams.length <= 0 ? (
              <NoTeams />
            ) : (
              <TeamList teams={teams} currentTeam={currentTeam} setCurrentTeam={this.setCurrentTeam} />
            )}
          </Loading>
        </Col>
      </Row>
    )
  }
}

export default ViewTeams
